<template>
    <div class="mainBox">
        <div class="main-header">
			<el-row :gutter="10">
				<el-col :span="6">
					<el-button type="primary" icon='el-icon-plus' size="medium" @click='handleInsert'>新增角色</el-button>
					<el-button icon='el-icon-refresh' size="medium" @click='init'>刷新</el-button>
				</el-col>
				<el-col :span="18">
					<el-form ref="search_form" :model="searchForm" class='search_form'>
						<el-row :gutter="10">
							<el-col :span="5" :offset="6">
                                <el-form-item prop="name">
                                    <el-input v-model="searchForm.name"  size="medium" placeholder="请输入角色名称" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item prop="code">
                                    <el-input v-model="searchForm.code" size="medium" placeholder="请输入角色代码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item prop="status">
                                    <el-select v-model="searchForm.status"  size="medium" placeholder="请选择状态" clearable>
                                        <el-option label="开启" value="active"></el-option>
                                        <el-option label="关闭" value="unactive"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" class="searchBtn" icon='el-icon-search' size="medium" @click='init'>查询</el-button>
                            </el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>
		</div>
        <div class="main-content">
            <el-table :data="mainLists" border>
                <el-table-column
                    type="index"
                    :index="1"
                    label="序号"
                    width="80px"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="角色名称"
                    min-width="100px">
                </el-table-column>
                <el-table-column
                    prop="code"
                    label="角色代码"
                    min-width="100px">
                </el-table-column>
                <el-table-column
                    prop="desc"
                    label="角色描述"
                    min-width="120px">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    min-width="80px">
                    <template slot-scope="scope">
                        <p>{{scope.row.status == 'active' ? '开启' : '关闭'}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="created_at"
                    label="创建时间"
                    align="center"
                    min-width="140px">
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="260px"
                    align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="success"
                            size="mini"
                            icon="el-icon-edit"
                            @click="handleMenu(scope.row,scope.$index)">
                            分配权限
                        </el-button>
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row,scope.$index)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination-footer" v-show="pagination.totalNum > 0">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pagination.page"
                :page-size="pagination.pageSize"
                :total="pagination.totalNum"
                @current-change="pageChangeHandle">
            </el-pagination>
        </div>
        <!--新增或编辑角色-->
        <el-dialog title="角色管理" :visible.sync="showRoleDialogVisible" @close="handleReset" :close-on-click-modal="false">
            <roleEdit ref="roleEdit" :roleForm="roleForm"></roleEdit>
            <template slot="footer">
                <el-button size="medium" @click="handleReset">取消</el-button>
                <el-button size="medium" type="primary" @click="handleSave">确定</el-button>
            </template>
        </el-dialog>
        <!-- 分配权限 -->
        <el-dialog title="权限管理" width="650px" :visible.sync="showMenuDialogVisible" :close-on-click-modal="false">
            <el-tree
                :data="menuLists"
                show-checkbox
                default-expand-all
                node-key="code"
                ref="menuTree"
                highlight-current
                :props="defaultProps">
            </el-tree>
            <template slot="footer">
                <el-button type="primary"  @click="handleSave2">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {roleList,roleCreate,roleUpdate,roleDelete,menuList,roleAccess} from '@/utils/getData';
    const roleEdit = ()=>import('@/components/content/roleEdit');

    export default {
        name: "list",
        components:{
            roleEdit
        },
        data(){
            return{
                searchForm:{
                    name:"",//角色名称
                    code:"",//角色代码
                    status:"",//状态
                },
                mainLists:[],//列表
                pagination: {
                    page: 1, //当前页数
                    pageSize: 20, //每页显示的条数
                    totalNum: 100 //总条数
                },
                showRoleDialogVisible:false,
                roleForm:{},//修改角色信息表单
                showMenuDialogVisible:false,//是否显示分配菜单权限
                menuLists:[],//权限列表
                menuForm:{},
                defaultProps: {
                    label: 'title'
                },
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(type){
                try{
                    if(type != "page"){
                        this.pagination.page = 1;
                    }
                    let formData = this.searchForm;
                    formData.page = this.pagination.page;
                    const res = await roleList(formData);
                    if (res.code == 0) {
                        this.pagination.totalNum = res.data.count;
                        this.mainLists = res.data.rows;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                    const res2 = await menuList({status:"active"});
                    if (res2.code == 0) {
                        this.menuLists = res2.data;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res2.message,
                            type: 'error'
                        });
                    }
                }catch (e) {
                    this.$message({
                        showClose: true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            pageChangeHandle(val){
                this.pagination.page = val;
                this.init("page");
            },
            handleInsert(){//新增
                this.roleForm = {status:"active"};
                this.showRoleDialogVisible = true;
            },
            handleEdit(currentRow){//编辑
                this.roleForm = JSON.parse(JSON.stringify(currentRow));
                this.showRoleDialogVisible = true;
            },
            handleSave(){//保存
                const roleForm = this.$refs["roleEdit"].$refs["roleForm"];
                roleForm.validate(async valid=>{
                    try{
                        if(valid){
                            let res = {},formData = roleForm.model;
                            if(formData.id){//编辑
                                if(formData.menus && Array.isArray(formData.menus)){
                                    formData.menus = formData.menus.join(",")
                                }
                                res = await roleUpdate(formData);
                            }else{//新增
                                res = await roleCreate(formData);
                            }
                            if (res.code == 0) {
                                if(formData.id){//编辑
                                    const index = this.mainLists.findIndex(item=>{
                                        return item.id == formData.id;
                                    });
                                    if(index != -1){
                                        this.$set(this.mainLists,index,res.data);
                                    }
                                }else{//新增
                                    this.mainLists.push(res.data);
                                }
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'success'
                                });
                                this.showRoleDialogVisible = false;
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }
                    }catch (e) {
                        this.$message({
                            showClose: true,
                            message: e.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDelete(currentRow,index){//删除
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await roleDelete({id:currentRow.id});
                    if (res.code == 0) {
                        this.mainLists.splice(index,1);
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch((e) => {
                    if(e == 'cancel'){
                        return false;
                    }
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                });
            },
            handleReset(){//重置表单
                this.$refs["roleEdit"].$refs["roleForm"].resetFields();
                this.showRoleDialogVisible = false;
            },
            handleMenu(currentRow,index){//显示分配权限列表
                this.menuForm = JSON.parse(JSON.stringify(currentRow));
                this.menuForm.pindex = index;
                let checkedKeys = currentRow.menus?currentRow.menus:[];
                this.showMenuDialogVisible = true;
                this.$nextTick(function(){
                    this.$refs['menuTree'].setCheckedKeys(checkedKeys);
                });
            },
            async handleSave2(){//分配权限
                try {
                    const that = this;
                    let formData = {};
                    formData.menus = this.$refs['menuTree'].getCheckedKeys(true);
                    formData.id = this.menuForm.id;
                    const res = await roleAccess(formData);
                    if (res.code == 0) {
                        this.$set(this.mainLists,this.menuForm.pindex,res.data);
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                        setTimeout(function(){
                            that.showMenuDialogVisible = false;
                        },500);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                } catch(e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
        }
    }
</script>

<style scoped>
</style>